import React from 'react'
import { ReactComponent as HappyEmoji } from 'assets/svg/emojis/emoji-happy.svg'
import { ComingSoonTitle, Sorry, ComingSoonCenterization } from './styled'

const ComingSoon = () => {
  return (
    <ComingSoonCenterization>
      <HappyEmoji />
      <ComingSoonTitle>Coming Soon 👋</ComingSoonTitle>
      <Sorry>Sorry this feature is not available yet. This feature will be released soon.</Sorry>
    </ComingSoonCenterization>
  )
}

export default ComingSoon
